module.exports = __webpack_public_path__ + "img/@news_list3.642a7c77.jpg";